import { render } from "./ApiDocV2.vue?vue&type=template&id=7b5bbb8c"
import script from "./ApiDocV2.vue?vue&type=script&lang=js"
export * from "./ApiDocV2.vue?vue&type=script&lang=js"

import "./ApiDocV2.vue?vue&type=style&index=0&id=7b5bbb8c&lang=css"

import exportComponent from "/codebuild/output/src1932422480/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__